//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.OperationBuilder.js";
import "../CAM/CAM.InspectionFeatureDataFilterBuilder.js";
import "../no/SelectPointList.js";
import "../no/SelectFace.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[1,"DataFilterBuilder",0,"CAM.InspectionFeatureDataFilterBuilder",0],[0,"EndUDistance",1,0],[0,"EndUPercent",1,0],[0,"EndVDistance",1,0],[0,"EndVPercent",1,0],[0,"IsPointDefinitionChanged",1,0],[0,"Name",1,0],[0,"NumberOfUPoints",1,0],[0,"NumberOfVPoints",1,0],[0,"PointDataDefinition",1,0],[1,"PointSelector",0,"SelectPointList",0],[0,"ReverseDirection",1,0],[1,"SelectedFace",0,"SelectFace",0],[1,"SelectedGeometry",0,"SelectNXObjectList",0],[0,"StartUDistance",1,0],[0,"StartUPercent",1,0],[0,"StartVDistance",1,0],[0,"StartVPercent",1,0],[0,"UStartEndMode",1,0],[0,"VStartEndMode",1,0]],[[["showExisting"],"PreviewPointData",{},1,0],[[],"ErasePointDefinitionDisplay",{},0,0]],[]];
SPLM.CAM.InspectionSurfaceFeatureBuilder = class extends SPLM.CAM.OperationBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.InspectionSurfaceFeatureBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.InspectionSurfaceFeatureBuilder.PointDataDefinitionType = Object.freeze({
    "None" : "None", "PointSet" : "PointSet", "IndividualPoints" : "IndividualPoints"});

SPLM.CAM.InspectionSurfaceFeatureBuilder.StartEndModeType = Object.freeze({
    "Percentage" : "Percentage", "Distance" : "Distance"});

export default SPLM;